(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-eu-withdrawal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    // Focus a field even when it already has focus, so screen readers announce its new error.
    function focusField(field) {
      if (field === document.activeElement) field.blur();
      field.focus();
    }

    function init(root) {
      if (!root || root.hasAttribute('data-cb-withdraw-ready')) return;
      var form = root.querySelector('form');
      var step1 = root.querySelector('[data-cb-withdraw-step="1"]');
      var step2 = root.querySelector('[data-cb-withdraw-step="2"]');
      // The thank-you state has no steps: nothing to wire up.
      if (!form || !step1 || !step2) return;
      root.setAttribute('data-cb-withdraw-ready', '');

      var continueBtn = root.querySelector('[data-cb-withdraw-continue]');
      var confirmBtn = root.querySelector('[data-cb-withdraw-confirm]');
      var backBtn = root.querySelector('[data-cb-withdraw-back]');
      var reviewTitle = root.querySelector('[data-cb-withdraw-review-title]');
      var time = root.querySelector('[data-cb-withdraw-time]');
      var fields = {
        name: form.querySelector('[name="contact[Full name]"]'),
        order: form.querySelector('[name="contact[Order reference]"]'),
        email: form.querySelector('[name="contact[email]"]'),
        items: form.querySelector('[name="contact[Items]"]'),
      };
      var confirmed = false;
      var unlockTimer = 0;
      var confirmText = confirmBtn ? confirmBtn.textContent : '';

      function unlock() {
        clearTimeout(unlockTimer);
        confirmed = false;
        confirmBtn.removeAttribute('aria-disabled');
        confirmBtn.textContent = confirmText;
      }

      // The error joins the field's description only while it shows, so screen readers don't read a
      // hidden error.
      function setInvalid(input, bad) {
        var error = document.getElementById(input.id + '-error');
        var described = (input.getAttribute('aria-describedby') || '').split(' ').filter(function (id) {
          return id && (!error || id !== error.id);
        });
        if (bad && error) described.push(error.id);
        if (described.length) input.setAttribute('aria-describedby', described.join(' '));
        else input.removeAttribute('aria-describedby');
        if (bad) input.setAttribute('aria-invalid', 'true');
        else input.removeAttribute('aria-invalid');
        if (error) error.hidden = !bad;
      }

      function check(key) {
        var input = fields[key];
        var value = input.value.trim();
        var bad = key === 'email' ? !EMAIL.test(value) : !value;
        setInvalid(input, bad);
        return !bad;
      }

      function valid() {
        var ok = true;
        ['name', 'order', 'email'].forEach(function (key) {
          if (!check(key)) ok = false;
        });
        return ok;
      }

      // The review opens at the top of the form; going back keeps the name field in view, even zoomed in.
      function show(step) {
        step1.hidden = step !== 1;
        step2.hidden = step !== 2;
        var target = step === 2 ? reviewTitle : fields.name;
        if (!target) return;
        var behavior = reduceMotion && reduceMotion.matches ? 'auto' : 'smooth';
        target.focus({ preventScroll: true });
        if (step === 2) root.scrollIntoView({ behavior: behavior, block: 'start' });
        else target.scrollIntoView({ behavior: behavior, block: 'center' });
      }

      function goToReview() {
        if (!valid()) {
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) focusField(first);
          return;
        }
        root.querySelectorAll('[data-cb-withdraw-show]').forEach(function (cell) {
          var key = cell.getAttribute('data-cb-withdraw-show');
          var value = fields[key] ? fields[key].value.trim() : '';
          cell.textContent = value || cell.getAttribute('data-cb-withdraw-whole') || '';
        });
        show(2);
      }

      // Fix a field as soon as it's corrected.
      ['name', 'order', 'email'].forEach(function (key) {
        fields[key].addEventListener('input', function () {
          if (fields[key].getAttribute('aria-invalid') === 'true') check(key);
        });
      });

      continueBtn.addEventListener('click', goToReview);
      // The form has no submit button, so Enter in a field does nothing by itself: move on to the review.
      ['name', 'order', 'email'].forEach(function (key) {
        fields[key].addEventListener('keydown', function (event) {
          if (event.key !== 'Enter' || event.isComposing) return;
          event.preventDefault();
          goToReview();
        });
      });
      backBtn.addEventListener('click', function () {
        show(1);
      });

      // Nothing is sent until the confirmation step.
      form.addEventListener('submit', function (event) {
        if (confirmed) return;
        event.preventDefault();
        // Stop other listeners too (Shopify's spam protection sends the form from its own listener).
        event.stopImmediatePropagation();
        if (step2.hidden) goToReview();
      });

      // Confirm is a plain button (type="button"), so the form is only ever sent from the review step:
      // not by Enter in a field (the live form sent at once) and not without JavaScript.
      confirmBtn.addEventListener('click', function (event) {
        event.preventDefault();
        if (step2.hidden) {
          goToReview();
          return;
        }
        if (confirmed) return;
        if (!valid()) {
          show(1);
          var first = form.querySelector('[aria-invalid="true"]');
          if (first) focusField(first);
          return;
        }
        if (time) time.value = new Date().toString();
        confirmed = true;
        confirmBtn.setAttribute('aria-disabled', 'true');
        var sending = confirmBtn.getAttribute('data-cb-withdraw-sending');
        if (sending) confirmBtn.textContent = sending;
        // If the send never leaves the page (a spam check closed, the connection lost), the button
        // unlocks again rather than staying on "Sending" for good.
        unlockTimer = setTimeout(unlock, 15000);
        if (form.requestSubmit) form.requestSubmit();
        else form.submit();
      });

      // Back to this page from the thank-you page: the browser may restore it as it was, mid-send.
      window.addEventListener('pageshow', function (event) {
        if (event.persisted) unlock();
      });
    }

    function initAll() {
      document.querySelectorAll('[data-cb-withdraw]').forEach(init);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Open the answer a link points to (/pages/superfood-faqs#caffeine), on load and on in-page links. */
    function openTarget() {
      var id = decodeURIComponent((window.location.hash || '').slice(1));
      if (!id) return;
      var el = document.getElementById(id);
      if (!el || !el.closest) return;
      var item = el.closest('.cb-faq__item');
      if (item && !item.open) item.open = true;
    }
    window.addEventListener('hashchange', openTarget);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', openTarget);
    } else {
      openTarget();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    var HEADER = '[data-cb-header]';

    var LOCK = 'data-cb-scroll-lock';
    /* Same breakpoint as the CSS that shows the burger and hides the desktop menu. */
    var phone = window.matchMedia ? window.matchMedia('(max-width: 1000px)') : null;

    function parts(root) {
      return {
        root: root,
        bar: root.querySelector('[data-cb-header-bar]'),
        shopItem: root.querySelector('[data-cb-shop]'),
        shopBtn: root.querySelector('[data-cb-shop-toggle]'),
        mega: root.querySelector('[data-cb-mega]'),
        burger: root.querySelector('[data-cb-burger]'),
        drawer: root.querySelector('[data-cb-drawer]'),
        searchBtn: root.querySelector('[data-cb-search-toggle]'),
        search: root.querySelector('[data-cb-search-panel]')
      };
    }

    /* Where the bar ends on screen (below the announcement bar at the top of the page, at the top of
       the screen once stuck): the menus fill or cap their height from there. */
    function setPanelTop(p) {
      if (!p.root || !p.bar) return;
      p.root.style.setProperty('--cb-panel-top', Math.round(p.bar.getBoundingClientRect().bottom) + 'px');
    }

    /* The page stays put under the phone menu and under the search panel (on every screen size). */
    function syncLock() {
      var locked = false;
      eachHeader(function (root, p) {
        if (isOpen(p.burger) && (!phone || phone.matches)) locked = true;
        if (isOpen(p.searchBtn)) locked = true;
      });
      document.documentElement.toggleAttribute(LOCK, locked);
    }

    function setOpen(trigger, panel, open, returnFocus) {
      if (!trigger || !panel) return;
      var root = trigger.closest(HEADER);
      if (open && root) setPanelTop(parts(root));
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
      var label = trigger.getAttribute(open ? 'data-label-close' : 'data-label-open');
      if (label) trigger.setAttribute('aria-label', label);
      panel.hidden = !open;
      if (panel.hasAttribute('data-cb-drawer') || panel.hasAttribute('data-cb-search-panel')) syncLock();
      if (!open && returnFocus) trigger.focus();
    }

    /* One menu at a time: opening the Shop menu, the phone menu or the search closes the others. */
    function closeOthers(p, keep) {
      if (keep !== p.shopBtn && isOpen(p.shopBtn)) setOpen(p.shopBtn, p.mega, false);
      if (keep !== p.burger && isOpen(p.burger)) setOpen(p.burger, p.drawer, false);
      if (keep !== p.searchBtn && isOpen(p.searchBtn)) setOpen(p.searchBtn, p.search, false);
    }

    /* The search panel opens with the cursor in its box (a tap opens the phone keyboard too). */
    function openSearch(p, open) {
      if (open) closeOthers(p, p.searchBtn);
      setOpen(p.searchBtn, p.search, open);
      var input = open && p.search.querySelector('[data-cb-search-input]');
      if (input) {
        input.focus({ preventScroll: true });
        if (input.value) input.select();
      }
    }

    function isOpen(trigger) {
      return !!trigger && trigger.getAttribute('aria-expanded') === 'true';
    }

    function eachHeader(fn) {
      document.querySelectorAll(HEADER).forEach(function (root) {
        fn(root, parts(root));
      });
    }

    /* Start loading the Shop menu images as soon as someone heads for the Shop button. */
    function warmMega(p) {
      if (!p.mega || p.mega.dataset.cbWarm) return;
      p.mega.dataset.cbWarm = 'true';
      p.mega.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
        img.loading = 'eager';
      });
    }

    document.addEventListener('pointerover', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var toggle = target.closest('[data-cb-shop-toggle]');
      if (toggle) warmMega(parts(toggle.closest(HEADER)));
    });

    document.addEventListener('focusin', function (event) {
      var target = event.target;
      if (target instanceof Element && target.matches('[data-cb-shop-toggle]')) {
        warmMega(parts(target.closest(HEADER)));
      }
    });

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      var toggle = target.closest('[data-cb-shop-toggle]');
      if (toggle) {
        var shop = parts(toggle.closest(HEADER));
        closeOthers(shop, shop.shopBtn);
        setOpen(shop.shopBtn, shop.mega, !isOpen(shop.shopBtn));
        return;
      }

      var burger = target.closest('[data-cb-burger]');
      if (burger) {
        var menu = parts(burger.closest(HEADER));
        closeOthers(menu, menu.burger);
        setOpen(menu.burger, menu.drawer, !isOpen(menu.burger));
        return;
      }

      var searchToggle = target.closest('[data-cb-search-toggle]');
      if (searchToggle) {
        var find = parts(searchToggle.closest(HEADER));
        openSearch(find, !isOpen(find.searchBtn));
        return;
      }

      /* Outside clicks close; so does following a link inside a menu (same-page anchors). */
      eachHeader(function (root, p) {
        if (isOpen(p.shopBtn) && (!p.shopItem.contains(target) || target.closest('[data-cb-mega] a'))) {
          setOpen(p.shopBtn, p.mega, false);
        }
        if (isOpen(p.burger) && (!p.drawer.contains(target) || target.closest('a'))) {
          setOpen(p.burger, p.drawer, false);
        }
        /* The dimmed page around the search sheet belongs to the panel: a click there closes it. */
        if (isOpen(p.searchBtn) && (!p.search.contains(target) || target === p.search || target.closest('a'))) {
          setOpen(p.searchBtn, p.search, false, target === p.search);
        }
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' && event.key !== 'Esc') return;
      var active = document.activeElement;
      var unfocused = !active || active === document.body;
      eachHeader(function (root, p) {
        /* Escape only closes the menu: Chromium would also empty a search box (WebKit doesn't). */
        if (isOpen(p.shopBtn) || isOpen(p.burger) || isOpen(p.searchBtn)) event.preventDefault();
        if (isOpen(p.shopBtn)) {
          setOpen(p.shopBtn, p.mega, false, unfocused || p.shopItem.contains(active));
        }
        if (isOpen(p.burger)) {
          setOpen(p.burger, p.drawer, false, unfocused || p.drawer.contains(active) || p.burger === active);
        }
        if (isOpen(p.searchBtn)) {
          setOpen(p.searchBtn, p.search, false, unfocused || p.search.contains(active) || p.searchBtn === active);
        }
      });
    });

    /* A search sent from the panel or the phone menu closes it (and frees the page) as the page
       changes, and so does leaving the page any other way: Back or Forward then never brings back a
       dimmed, locked page from the browser's cache. */
    function closeAll() {
      eachHeader(function (root, p) {
        setOpen(p.shopBtn, p.mega, false);
        setOpen(p.burger, p.drawer, false);
        setOpen(p.searchBtn, p.search, false);
      });
      document.documentElement.removeAttribute(LOCK);
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!(form instanceof Element) || !form.closest('[data-cb-search-panel], [data-cb-drawer]')) return;
      var p = parts(form.closest(HEADER));
      if (form.closest('[data-cb-search-panel]')) setOpen(p.searchBtn, p.search, false);
      if (form.closest('[data-cb-drawer]')) setOpen(p.burger, p.drawer, false);
    });

    window.addEventListener('pagehide', closeAll);

    /* Close a menu when keyboard focus moves somewhere outside it. */
    document.addEventListener('focusout', function (event) {
      var next = event.relatedTarget;
      if (!(next instanceof Element)) return;
      eachHeader(function (root, p) {
        if (isOpen(p.shopBtn) && p.shopItem.contains(event.target) && !p.shopItem.contains(next)) {
          setOpen(p.shopBtn, p.mega, false);
        }
        if (
          isOpen(p.burger) &&
          (p.drawer.contains(event.target) || p.burger === event.target) &&
          !p.drawer.contains(next) &&
          p.burger !== next
        ) {
          setOpen(p.burger, p.drawer, false);
        }
        if (
          isOpen(p.searchBtn) &&
          (p.search.contains(event.target) || p.searchBtn === event.target) &&
          !p.search.contains(next) &&
          p.searchBtn !== next
        ) {
          setOpen(p.searchBtn, p.search, false);
        }
      });
    });

    /* Keyboard focus never stays hidden under the stuck bar (WCAG 2.4.11). Browsers scroll a focused
       element into view only when it is off screen, so a link already on screen under the bar would
       stay covered. Once any scrolling has settled, it is brought to just below the bar. Focus that
       follows a click or tap is left alone, and so is a visitor who scrolls or swipes meanwhile. */
    var reveal = { el: null, timer: 0, until: 0, pointer: 0 };

    function pageScroller() {
      var wrapper = document.querySelector('.page-wrapper');
      if (wrapper && wrapper.scrollHeight > wrapper.clientHeight && getComputedStyle(wrapper).overflowY !== 'visible') {
        return wrapper;
      }
      return document.scrollingElement || document.documentElement;
    }

    function revealFocus() {
      var el = reveal.el;
      reveal.el = null;
      reveal.timer = 0;
      if (!el || el !== document.activeElement) return;
      var root = document.querySelector(HEADER + '[data-cb-sticky]');
      var bar = root && root.querySelector('[data-cb-header-bar]');
      if (!bar) return;
      var limit = bar.getBoundingClientRect().bottom;
      var box = el.getBoundingClientRect();
      if (limit <= 0 || box.height === 0 || box.top >= limit - 1) return;
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      pageScroller().scrollBy({ top: box.top - limit - 8, behavior: still ? 'instant' : 'smooth' });
    }

    function revealSoon() {
      clearTimeout(reveal.timer);
      reveal.timer = setTimeout(revealFocus, 150);
    }

    function revealCancel() {
      reveal.el = null;
      clearTimeout(reveal.timer);
    }

    document.addEventListener(
      'pointerdown',
      function () {
        reveal.pointer = Date.now();
        revealCancel();
      },
      true
    );

    document.addEventListener('focusin', function (event) {
      var el = event.target;
      if (!(el instanceof Element) || el.closest(HEADER) || el.closest('dialog')) return;
      if (Date.now() - reveal.pointer < 600) return;
      reveal.el = el;
      reveal.until = Date.now() + 1500;
      revealSoon();
    });

    document.addEventListener(
      'scroll',
      function () {
        if (reveal.el && Date.now() < reveal.until) revealSoon();
      },
      { capture: true, passive: true }
    );

    ['wheel', 'touchstart'].forEach(function (type) {
      window.addEventListener(type, revealCancel, { capture: true, passive: true });
    });

    /* Keep an open menu sized to the screen (rotation, browser bars, window resize). */
    window.addEventListener('resize', function () {
      eachHeader(function (root, p) {
        if (isOpen(p.burger) || isOpen(p.shopBtn) || isOpen(p.searchBtn)) setPanelTop(p);
      });
    });

    /* Crossing the menu breakpoint closes the menu that no longer shows (and frees the page). */
    function onBreakpoint() {
      eachHeader(function (root, p) {
        if (phone.matches && isOpen(p.shopBtn)) setOpen(p.shopBtn, p.mega, false);
        if (!phone.matches && isOpen(p.burger)) setOpen(p.burger, p.drawer, false);
      });
      syncLock();
    }
    if (phone) {
      if (phone.addEventListener) phone.addEventListener('change', onBreakpoint);
      else if (phone.addListener) phone.addListener(onBreakpoint);
    }

    /* Theme editor: a reloaded header is measured again (sticky offset, --header-height), and a
       removed one never leaves the page locked. */
    document.addEventListener('shopify:section:load', function () {
      if (window.cbHeader && window.cbHeader.watch) window.cbHeader.watch();
      syncLock();
    });

    document.addEventListener('shopify:section:unload', function (event) {
      var target = event.target;
      if (target instanceof Element && target.querySelector(HEADER)) {
        document.documentElement.removeAttribute(LOCK);
        // A reloaded header sets it again (watch, on shopify:section:load).
        document.documentElement.removeAttribute('data-cb-header-on');
      }
    });

    /* Theme editor: show the menu that holds the selected block. Listeners are delegated, so a
       section reload (shopify:section:load) needs no re-initialising. */
    document.addEventListener('shopify:block:select', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var root = target.closest(HEADER);
      if (!root) return;
      var p = parts(root);
      if (target.closest('[data-cb-mega]')) setOpen(p.shopBtn, p.mega, true);
      if (target.closest('[data-cb-drawer]')) setOpen(p.burger, p.drawer, true);
    });

    document.addEventListener('shopify:block:deselect', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;
      var root = target.closest(HEADER);
      if (!root) return;
      var p = parts(root);
      setOpen(p.shopBtn, p.mega, false);
      setOpen(p.burger, p.drawer, false);
      setOpen(p.searchBtn, p.search, false);
    });

    /* Basket count. assets/cb-cart.js writes the number on cb:cart-updated; this keeps the
       screen reader wording (item / items) in step, and also follows Horizon's own cart events
       (product pages and cart drawer that use Horizon's forms) and back/forward cache restores. */
    /* Written into the existing text node, and only when it changes: a new node under the pointer
       between mouse-down and mouse-up makes WebKit (Safari) drop the click on the basket button. */
    function setText(el, text) {
      var node = el.firstChild;
      if (node && node.nodeType === 3 && node === el.lastChild) {
        if (node.nodeValue !== text) node.nodeValue = text;
      } else if (el.textContent !== text) {
        el.textContent = text;
      }
    }

    function setUnits(count) {
      document.querySelectorAll('[data-cb-cart-unit]').forEach(function (el) {
        setText(el, (count === 1 ? el.dataset.one : el.dataset.other) || '');
      });
    }

    function setCount(count) {
      document.querySelectorAll('[data-cb-cart-count]').forEach(function (el) {
        setText(el, String(count));
      });
      setUnits(count);
    }

    document.addEventListener('cb:cart-updated', function (event) {
      if (event.detail && typeof event.detail.item_count === 'number') setUnits(event.detail.item_count);
    });

    document.addEventListener('shopify:cart:lines-update', function (event) {
      if (!event.promise || typeof event.promise.then !== 'function') return;
      event.promise
        .then(function (result) {
          var cart = result && result.cart;
          var detail = result && result.detail;
          var count = cart && typeof cart.totalQuantity === 'number' ? cart.totalQuantity : detail && detail.itemCount;
          if (typeof count === 'number') setCount(count);
        })
        .catch(function () {});
    });

    window.addEventListener('pageshow', function (event) {
      if (!event.persisted) return;
      var link = document.querySelector('[data-cb-cart-link]');
      if (!link || !window.fetch) return;
      fetch(link.getAttribute('data-cb-cart-link') + '.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.item_count === 'number') setCount(cart.item_count);
        })
        .catch(function () {});
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cb-hero-slider')) return;
    var reduceMotion = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

    // Campaign banner slideshow. Autoplay only when switched on in the editor, never for visitors
    // who prefer reduced motion; pauses on hover, on focus and when the visitor uses the controls.
    class CbHeroSlider extends HTMLElement {
      connectedCallback() {
        this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-cb-slide]'));
        this.controls = this.querySelector('[data-cb-controls]');
        if (this.slides.length < 2 || !this.controls) return;

        this.track = this.querySelector('[data-cb-track]');
        this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-cb-dot]'));
        this.pauseButton = this.querySelector('[data-cb-pause]');
        this.index = 0;
        this.hovering = false;
        this.focused = false;
        this.editorHold = false;
        this.autoplay = this.dataset.autoplay === 'true' && !(reduceMotion && reduceMotion.matches);
        this.paused = !this.autoplay;
        this.delay = Math.max(3, parseInt(this.dataset.speed, 10) || 6) * 1000;
        if (this.pauseButton && !this.autoplay) this.pauseButton.hidden = true;
        this.controls.hidden = false;

        this.onClick = this.onClick.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onSelect = this.onSelect.bind(this);
        this.onDeselect = this.onDeselect.bind(this);
        this.onVisibility = this.schedule.bind(this);
        this.controls.addEventListener('click', this.onClick);
        this.controls.addEventListener('keydown', this.onKeydown);
        this.addEventListener('mouseenter', () => { this.hovering = true; this.schedule(); });
        this.addEventListener('mouseleave', () => { this.hovering = false; this.schedule(); });
        this.addEventListener('focusin', () => { this.focused = true; this.schedule(); });
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) {
            this.focused = false;
            this.schedule();
          }
        });
        var startX = null;
        this.track.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
        this.track.addEventListener('touchend', (event) => {
          if (startX === null) return;
          var dx = event.changedTouches[0].clientX - startX;
          startX = null;
          if (Math.abs(dx) > 40) this.stopAndGo(this.index + (dx < 0 ? 1 : -1));
        });
        document.addEventListener('shopify:block:select', this.onSelect);
        document.addEventListener('shopify:block:deselect', this.onDeselect);
        document.addEventListener('visibilitychange', this.onVisibility);
        this.schedule();
      }

      disconnectedCallback() {
        clearTimeout(this.timer);
        document.removeEventListener('shopify:block:select', this.onSelect);
        document.removeEventListener('shopify:block:deselect', this.onDeselect);
        document.removeEventListener('visibilitychange', this.onVisibility);
      }

      onClick(event) {
        var button = event.target.closest('button');
        if (!button) return;
        if (button.hasAttribute('data-cb-prev')) this.stopAndGo(this.index - 1);
        else if (button.hasAttribute('data-cb-next')) this.stopAndGo(this.index + 1);
        else if (button.hasAttribute('data-cb-dot')) this.stopAndGo(parseInt(button.getAttribute('data-cb-dot'), 10));
        else if (button.hasAttribute('data-cb-pause')) this.setPaused(!this.paused);
      }

      onKeydown(event) {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.stopAndGo(this.index - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.stopAndGo(this.index + 1);
        }
      }

      onSelect(event) {
        var slide = event.target && event.target.closest ? event.target.closest('[data-cb-slide]') : null;
        if (!slide || !this.contains(slide)) return;
        this.editorHold = true;
        this.go(this.slides.indexOf(slide));
      }

      onDeselect(event) {
        if (event.target && this.contains(event.target)) {
          this.editorHold = false;
          this.schedule();
        }
      }

      stopAndGo(index) {
        if (this.autoplay && !this.paused) this.setPaused(true);
        this.go(index);
      }

      setPaused(paused) {
        this.paused = paused;
        if (this.pauseButton) {
          this.pauseButton.toggleAttribute('data-paused', paused);
          this.pauseButton.setAttribute(
            'aria-label',
            paused ? this.pauseButton.dataset.labelPlay : this.pauseButton.dataset.labelPause
          );
        }
        this.track.setAttribute('aria-live', paused || !this.autoplay ? 'polite' : 'off');
        this.schedule();
      }

      go(index) {
        var count = this.slides.length;
        var next = ((index % count) + count) % count;
        this.slides.forEach(function (slide, i) {
          if (i === next) {
            slide.setAttribute('data-active', '');
            slide.removeAttribute('aria-hidden');
            slide.removeAttribute('inert');
          } else {
            slide.removeAttribute('data-active');
            slide.setAttribute('aria-hidden', 'true');
            slide.setAttribute('inert', '');
          }
        });
        this.dots.forEach(function (dot, i) {
          if (i === next) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.index = next;
        this.schedule();
      }

      schedule() {
        clearTimeout(this.timer);
        if (!this.autoplay || this.paused || this.hovering || this.focused || this.editorHold || document.hidden) return;
        this.timer = setTimeout(() => this.go(this.index + 1), this.delay);
      }
    }

    customElements.define('cb-hero-slider', CbHeroSlider);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Sign-up links (snippets/cb-signup-link.liquid, FAQ answers; James, 14 Oct 2026): a link to this band's
       anchor (#sign-up) scrolls the band into view and puts the cursor in its email field, or on the band when
       only an app form is in it. Without JavaScript the link still jumps to the band. One listener per page. */
    if (window.cbSignupLinks) return;
    window.cbSignupLinks = true;
    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      var link = event.target && event.target.closest ? event.target.closest('a[href*="#"]') : null;
      if (!link || !link.hash || link.host !== window.location.host || link.pathname !== window.location.pathname) return;
      var band = document.getElementById(decodeURIComponent(link.hash.slice(1)));
      if (!band || !band.hasAttribute('data-cb-signup-target')) return;
      event.preventDefault();
      var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var field = band.querySelector('input[type="email"]:not([disabled])');
      band.scrollIntoView({ behavior: still ? 'auto' : 'smooth', block: 'center' });
      if (!field) {
        field = band;
        band.setAttribute('tabindex', '-1');
      }
      field.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-pdp-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cb-pdp-ingredients-rows')) return;
    // A name that wraps onto a second line in one card would push its figure and short line below
    // the rest of the row (Cacao Bliss "Vitamin D & B12 (BIOVIT)"; "Arabica coffee" at 1101 to
    // 1180px). Every name in a row gets the height of the row's tallest, so names, figures and short
    // lines start on the same lines (design QA, 11 Oct 2026). Enhancement only: without it the cards
    // read the same, just less evenly. Watches the names, never the rows it sizes, so it can't loop.
    class CbPdpIngredientsRows extends HTMLElement {
      connectedCallback() {
        if (!('ResizeObserver' in window)) return;
        this.queued = false;
        this.observer = new ResizeObserver(() => this.queue());
        this.querySelectorAll('.cb-pdp-ingredients__name').forEach((name) => this.observer.observe(name));
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.queue());
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      queue() {
        if (this.queued) return;
        this.queued = true;
        requestAnimationFrame(() => {
          this.queued = false;
          this.update();
        });
      }
      update() {
        const rows = new Map();
        this.querySelectorAll('.cb-pdp-ingredients__name-row').forEach((nameRow) => {
          nameRow.style.minHeight = '';
          const card = nameRow.closest('.cb-pdp-ingredients__card');
          const top = Math.round(card.getBoundingClientRect().top);
          if (!rows.has(top)) rows.set(top, []);
          rows.get(top).push(nameRow);
        });
        rows.forEach((row) => {
          if (row.length < 2) return;
          const heights = row.map((nameRow) => nameRow.getBoundingClientRect().height);
          const tallest = Math.max(...heights);
          row.forEach((nameRow, i) => {
            if (heights[i] < tallest - 0.5) nameRow.style.minHeight = tallest + 'px';
          });
        });
      }
    }
    customElements.define('cb-pdp-ingredients-rows', CbPdpIngredientsRows);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-pdp-lifestyle"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function findBuyBox() {
      return document.querySelector('[data-cb-buy-box]') || document.querySelector('form[data-cb-add-form]');
    }
    document.addEventListener('click', function (event) {
      var cta = event.target.closest ? event.target.closest('[data-cb-pdp-lifestyle-cta]') : null;
      if (!cta) return;
      var target = findBuyBox();
      if (!target) return;
      event.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      if (cta.getAttribute('data-cb-pdp-lifestyle-cta') === 'subscribe') {
        document.dispatchEvent(new CustomEvent('cb:select-purchase-option', { detail: { option: 'subscribe' } }));
      }
      var field = target.querySelector(
        'input:not([type="hidden"]):not([disabled]), select:not([disabled]), button:not([disabled])'
      );
      if (field) field.focus({ preventScroll: true });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-pdp-main"] && !Shopify.designMode) return;
  try {
    
  /* CB Product buy box: variant picker, quantity stepper and add to basket label. */
  (function () {
    'use strict';

    /* Formats cents with the shop's money format (amount token in double braces). */
    function formatMoney(cents, format) {
      var fmt = String(format || '').replace(/<[^>]*>/g, '');
      var token = /\{\{\s*(\w+)\s*\}\}/;
      var match = fmt.match(token);
      function delimit(value, precision, thousands, decimal) {
        var fixed = (Number(value || 0) / 100).toFixed(precision);
        var parts = fixed.split('.');
        var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        return parts[1] ? whole + decimal + parts[1] : whole;
      }
      if (!match) return '£' + delimit(cents, 2, ',', '.');
      var out;
      switch (match[1]) {
        case 'amount_no_decimals':
          out = delimit(cents, 0, ',', '.');
          break;
        case 'amount_with_comma_separator':
          out = delimit(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          out = delimit(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          out = delimit(cents, 2, "'", '.');
          break;
        default:
          out = delimit(cents, 2, ',', '.');
      }
      return fmt.replace(token, out);
    }

    function initPdp(root) {
      if (!root || root.hasAttribute('data-cb-pdp-ready')) return;
      var dataEl = root.querySelector('[data-cb-pdp-json]');
      if (!dataEl) return;
      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }
      root.setAttribute('data-cb-pdp-ready', '');

      var sectionId = root.getAttribute('data-section-id');
      var variants = data.variants || [];
      var form = root.querySelector('form[data-cb-add-form]');
      var idInput = root.querySelector('[data-cb-variant-input]');
      var qtyInput = root.querySelector('[data-cb-qty-input]');
      var addBtn = root.querySelector('[data-cb-add]');
      var express = root.querySelector('[data-cb-express]');
      var spoksBis = root.querySelector('[data-spoks-bis-trigger]');
      var groups = Array.prototype.slice.call(root.querySelectorAll('[data-cb-option]'));
      var soldNote = root.querySelector('[data-cb-sold-note]');
      var qtyLive = root.querySelector('[data-cb-qty-live]');
      var leadPrice = root.querySelector('[data-cb-lead-price]');
      var leadWas = root.querySelector('[data-cb-lead-was]');
      /* Sitewide sale (snippets/cb-sale.liquid): the price block by the name and the sticky bar's struck price and
         label. Present only while the sale is live and the product is sold one-off; on while <html> has cb-sale-on. */
      var saleLead = root.querySelector('[data-cb-lead-sale]');
      var saleSticky = root.querySelector('[data-cb-sticky-sale]');
      var sticky = root.querySelector('[data-cb-pdp-sticky]');
      var stickyBtn = sticky && sticky.querySelector('[data-cb-pdp-sticky-add]');
      var stickyText = sticky && sticky.querySelector('[data-cb-pdp-sticky-text]');
      var stickyMeta = sticky && sticky.querySelector('[data-cb-pdp-sticky-meta]');
      /* A block that must be finished before anything can be added holds the button off with its own label:
         the Tea box chooser (snippets/cb-tea-box-chooser.liquid) while fewer than 4 teas are chosen, or
         "Coming soon" while the box has no subscription plans. It announces a change with cb:buy-hold. Other
         product pages have no such block. */
      var holdEl = root.querySelector('[data-cb-buy-hold]');
      var current = null;

      function attr(name) {
        return (addBtn && addBtn.getAttribute(name)) || '';
      }

      function money(cents) {
        return formatMoney(cents, data.money_format);
      }

      function saleOn() {
        return Boolean(saleLead && window.CBSale && window.CBSale.on());
      }

      function selectedOptions() {
        return groups.map(function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(options) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var ok = true;
          for (var j = 0; j < options.length; j++) {
            if (!v.options || v.options[j] !== options[j]) {
              ok = false;
              break;
            }
          }
          if (ok) return v;
        }
        return null;
      }

      function findById(id) {
        for (var i = 0; i < variants.length; i++) {
          if (String(variants[i].id) === String(id)) return variants[i];
        }
        return null;
      }

      /* Availability and price per option value, given the other selected options. A sold-out
         value stays selectable (the back-in-stock form shows); a value with no variant does not. */
      function refreshOptions(options) {
        groups.forEach(function (group, index) {
          var inputs = group.querySelectorAll('input[type="radio"]');
          Array.prototype.forEach.call(inputs, function (input) {
            var test = options.slice();
            test[index] = input.value;
            var v = findVariant(test);
            var ok = Boolean(v && v.available);
            input.disabled = !v;
            input.parentNode.classList.toggle('is-sold-out', !ok);
            var meta = input.parentNode.querySelector('[data-cb-size-meta]');
            if (!meta) return;
            var note = ok ? input.getAttribute('data-note') || '' : attr(v ? 'data-sold-out-label' : 'data-unavailable-label');
            /* Same markup as the Liquid: price, separator, note (the note takes its own line on phones). A sitewide
               sale block (snippets/cb-sale.liquid) is kept and refilled for this size, before the price it replaces. */
            var saleTile = meta.querySelector('[data-cb-sale-block]');
            meta.textContent = '';
            if (v && saleTile && window.CBSale) {
              window.CBSale.fill(saleTile, money(v.price), money(window.CBSale.price(v.price)));
              meta.appendChild(saleTile);
            }
            function part(className, text) {
              var span = document.createElement('span');
              span.className = className;
              span.textContent = text;
              meta.appendChild(span);
            }
            if (v) part('cb-pdp__size-price cb-sale-orig', money(v.price));
            if (note) {
              part('cb-pdp__size-sep', '\u00a0· ');
              part('cb-pdp__size-status', note);
            }
          });
        });
      }

      function planPrice(v) {
        if (!form || !v) return null;
        var plan = null;
        try {
          plan = new FormData(form).get('selling_plan');
        } catch (err) {
          plan = null;
        }
        if (!plan) return null;
        var allocations = v.selling_plan_allocations || [];
        for (var i = 0; i < allocations.length; i++) {
          if (String(allocations[i].selling_plan_id) === String(plan)) {
            /* The price from order 2 on (the last price adjustment), as the buy box shows it:
               James's plan is 0% on order 1 with a 15% automatic discount for the first payment. */
            var steps = allocations[i].price_adjustments || [];
            return steps.length ? steps[steps.length - 1].price : allocations[i].price;
          }
        }
        return null;
      }

      /* A button's label is written into its existing text node, and only when it changes. The mouse-down
         on Add to basket takes focus off the quantity box, which fires change and re-renders the label
         before the mouse-up: a new text node under the pointer makes WebKit (Safari on a Mac, iPad with a
         trackpad) drop the click, so nothing was added on the first click. */
      function setLabel(el, label) {
        if (!el) return;
        var node = el.firstChild;
        if (node && node.nodeType === 3 && node === el.lastChild) {
          if (node.nodeValue !== label) node.nodeValue = label;
        } else if (el.textContent !== label) {
          el.textContent = label;
        }
      }

      function renderButton() {
        if (!addBtn) return;
        var v = current;
        var label;
        var disabled = false;
        if (!v) {
          label = attr('data-unavailable-label');
          disabled = true;
        } else if (!v.available) {
          label = attr('data-sold-out-label');
          disabled = true;
        } else {
          var subPrice = planPrice(v);
          var isSub = subPrice !== null;
          /* One-off during a sitewide sale: the price the basket will charge. */
          var unit = isSub ? subPrice : saleOn() ? window.CBSale.price(v.price) : v.price;
          label = (isSub && attr('data-subscribe-label')) || attr('data-add-label');
          if (addBtn.hasAttribute('data-show-price')) {
            var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
            var total = money(unit * qty);
            /* Non-breaking space: the dot never starts a new line. */
            label = label ? label + '\u00a0· ' + total : total;
          }
        }
        /* Price by the name: the chosen size's price (the plan price while a subscription is
           chosen), whether or not it can be bought; hidden when no size matches. */
        if (leadPrice) {
          var leadNow = v ? (disabled ? v.price : unit) : null;
          /* Struck: the one-off price while a subscription is chosen (not on the Tea Box, data-cb-sub-was="off":
             never sold one-off), else a bundle's checked saving added to its price (data-cb-save); never the raw
             compare-at (Compliance, 11 Oct 2026). */
          /* With Show sale prices on single products on (data-cb-sale), a single product's compare-at, read out
             as "Was"; a bundle's struck price reads "Bought separately". */
          var leadP = leadPrice.parentNode;
          var leadSave = parseInt(leadP.getAttribute('data-cb-save'), 10) || 0;
          var leadSale = leadP.getAttribute('data-cb-sale') === 'true' && leadP.getAttribute('data-cb-bundle') !== '1';
          var leadThen = null;
          var leadLabel = '';
          if (v && !disabled && isSub && leadP.getAttribute('data-cb-sub-was') !== 'off') {
            leadThen = v.price;
          } else if (v && leadSave > 0) {
            leadThen = v.price + leadSave;
            leadLabel = leadP.getAttribute('data-cb-was-label') || '';
          } else if (v && leadSale && v.compare_at_price > v.price) {
            leadThen = v.compare_at_price;
            leadLabel = leadP.getAttribute('data-cb-sale-label') || '';
          }
          leadP.hidden = !v;
          setLabel(leadPrice, v ? money(leadNow) : '');
          if (leadWas) {
            leadWas.hidden = !(leadThen > leadNow);
            setLabel(leadWas, leadThen > leadNow ? money(leadThen) : '');
          }
          var leadSr = leadP.querySelector('[data-cb-lead-was-sr]');
          if (leadSr) {
            setLabel(leadSr, leadThen > leadNow && leadLabel ? leadLabel + ' ' + money(leadThen) : '');
            leadSr.hidden = !leadSr.textContent;
          }
        }
        /* Sitewide sale: shown for the chosen size while a one-off is chosen (sold out too: its price is shown);
           hidden while a subscription is chosen, so the plan price and struck one-off price show as before. */
        var saleNow = Boolean(v) && !(isSub && !disabled);
        [saleLead, saleSticky].forEach(function (el) {
          if (!el) return;
          el.hidden = !saleNow;
          if (v && window.CBSale) window.CBSale.fill(el, money(v.price), money(window.CBSale.price(v.price)));
        });
        /* Held (see holdEl): off, with the block's label and no price; the price by the name stays. */
        var held = holdEl ? holdEl.getAttribute('data-cb-buy-hold') || '' : '';
        if (held && !disabled) {
          label = held;
          disabled = true;
        }
        addBtn.disabled = disabled;
        if (express) express.hidden = disabled;
        /* Spoks back-in-stock slot: shown only while the chosen size exists and is sold out. */
        if (spoksBis) spoksBis.hidden = !(v && !v.available);
        var text = addBtn.querySelector('[data-cb-add-text]');
        setLabel(text || addBtn, label);
        if (stickyBtn) {
          stickyBtn.disabled = disabled;
          setLabel(stickyText, label);
          setLabel(stickyMeta, v && variants.length > 1 ? v.title : '');
          stickyBuyable = !disabled;
          updateSticky();
        }
      }

      /* Sticky bar: on once the visitor has scrolled past the main button (it stays on from there
         down, and goes when they scroll back up to the button), while the size can be bought and the
         page is a single column. Not shown above the button, so it never flickers on and off. */
      var stickyBuyable = false;
      var addPassed = false;
      var stickyQuery = window.matchMedia ? window.matchMedia('(max-width: 1100px)') : null;

      function updateSticky() {
        if (!sticky || sticky.getAttribute('data-show') === 'false') return;
        var on = stickyBuyable && addPassed && Boolean(stickyQuery && stickyQuery.matches);
        if (sticky.hidden !== on) return;
        sticky.hidden = !on;
        var html = document.documentElement;
        html.classList.toggle('cb-sticky-buy-on', on);
        if (on) html.style.setProperty('--cb-sticky-buy-h', sticky.offsetHeight + 'px');
      }

      if (sticky && stickyBtn && addBtn && sticky.getAttribute('data-show') !== 'false' && 'IntersectionObserver' in window) {
        /* The observed area runs from the top of the screen to far below it, so the button leaving it
           always means "scrolled past the top", even after a jump (End key, an anchor, Back) that
           takes it from below the screen to above it without ever being on screen. */
        var stickyObserver = new IntersectionObserver(
          function (entries) {
            var entry = entries[entries.length - 1];
            addPassed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            updateSticky();
          },
          { rootMargin: '0px 0px 100000px 0px' }
        );
        stickyObserver.observe(addBtn);
        /* A jump (anchor, Home/End, scrollTo) can skip the observer's crossing: re-check on scroll, once a frame.
           Capture also catches the page wrapper, which scrolls instead of the window in Horizon's desktop layout. */
        var stickyTick = false;
        document.addEventListener('scroll', function () {
          if (stickyTick) return;
          stickyTick = true;
          window.requestAnimationFrame(function () {
            stickyTick = false;
            var passed = addBtn.getBoundingClientRect().bottom < 0;
            if (passed !== addPassed) {
              addPassed = passed;
              updateSticky();
            }
          });
        }, { capture: true, passive: true });
        /* The bar's height can change while it shows (turning a phone round changes the safe area under
           it, which is padding, so the border box is watched): keep --cb-sticky-buy-h current, so the
           page's end and Langify's switcher stay clear of it. */
        var stickySize = 'ResizeObserver' in window
          ? new ResizeObserver(function () {
              if (!sticky.hidden && sticky.offsetHeight) {
                document.documentElement.style.setProperty('--cb-sticky-buy-h', sticky.offsetHeight + 'px');
              }
            })
          : null;
        if (stickySize) stickySize.observe(sticky, { box: 'border-box' });
        /* Theme editor: a re-rendered or removed section leaves no bar state behind. */
        document.addEventListener('shopify:section:unload', function (event) {
          if (!event.target || !event.target.contains(root)) return;
          stickyObserver.disconnect();
          if (stickySize) stickySize.disconnect();
          document.documentElement.classList.remove('cb-sticky-buy-on');
        });
        if (stickyQuery) {
          if (stickyQuery.addEventListener) stickyQuery.addEventListener('change', updateSticky);
          else if (stickyQuery.addListener) stickyQuery.addListener(updateSticky);
        }
        /* A basket error prints by the main button: bring it into view when the bar sent the add. */
        document.addEventListener('cb:cart-error', function (event) {
          if (sticky.hidden || !event.detail || event.detail.form !== form) return;
          window.setTimeout(function () {
            var slot = root.querySelector('[data-cb-add-error]');
            if (slot && !slot.hidden) slot.scrollIntoView({ block: 'center' });
          }, 0);
        });
      } else {
        stickyBtn = null;
      }

      function schedule() {
        window.setTimeout(renderButton, 0);
      }

      function setVariant(v, announce) {
        current = v;
        if (v && idInput) idInput.value = v.id;
        renderButton();
        if (!v || !announce) return;
        if (root.hasAttribute('data-cb-update-url') && window.history && window.history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState(window.history.state, '', url.toString());
          } catch (err) {
            /* The URL update is a nicety only. */
          }
        }
        document.dispatchEvent(new CustomEvent('cb:variant-change', { detail: { variant: v, sectionId: sectionId } }));
      }

      groups.forEach(function (group) {
        group.addEventListener('change', function () {
          if (soldNote) soldNote.hidden = true;
          var options = selectedOptions();
          refreshOptions(options);
          setVariant(findVariant(options), true);
        });
      });

      function clampQty() {
        if (!qtyInput) return;
        var min = parseInt(qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || Infinity;
        var value = parseInt(qtyInput.value, 10);
        if (isNaN(value) || value < min) value = min;
        if (value > max) value = max;
        if (String(value) !== qtyInput.value) qtyInput.value = value;
      }

      Array.prototype.forEach.call(root.querySelectorAll('[data-cb-qty-step]'), function (btn) {
        btn.addEventListener('click', function () {
          if (!qtyInput) return;
          var step = parseInt(qtyInput.step, 10) || 1;
          var direction = parseInt(btn.getAttribute('data-cb-qty-step'), 10) || 0;
          var value = parseInt(qtyInput.value, 10) || 0;
          qtyInput.value = value + step * direction;
          clampQty();
          if (qtyLive) qtyLive.textContent = (qtyLive.getAttribute('data-label') || '') + ' ' + qtyInput.value;
          qtyInput.dispatchEvent(new Event('input', { bubbles: true }));
          qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      if (qtyInput) {
        qtyInput.addEventListener('blur', clampQty);
        /* The total on the button follows each key, so it is already right before the box loses focus. */
        qtyInput.addEventListener('input', renderButton);
      }

      /* The purchase options snippet writes the selling_plan input inside the form and
         announces changes with cb:plan-change (bubbles) and a change event on that input. */
      if (form) {
        form.addEventListener('change', schedule);
        form.addEventListener('input', schedule);
        form.addEventListener('cb:plan-change', schedule);
      }
      if (holdEl) root.addEventListener('cb:buy-hold', renderButton);
      /* The sitewide sale ended while the page was open (snippets/cb-sale.liquid): full prices on the button again. */
      if (saleLead) document.addEventListener('cb:sale-end', renderButton);

      /* The Spoks slot sits inside this form: a button Spoks puts there never adds to the basket, even
         without type="button". A form of Spoks's own inside the slot is left alone. */
      if (form && spoksBis) {
        form.addEventListener('submit', function (event) {
          if (event.target !== form || !event.submitter || !spoksBis.contains(event.submitter)) return;
          event.preventDefault();
          event.stopPropagation();
        }, true);
      }

      var initial = groups.length ? findVariant(selectedOptions()) : null;
      if (!initial) initial = findById(data.selected_variant_id) || variants[0] || null;
      var restored = Boolean(initial && String(initial.id) !== String(data.selected_variant_id));
      if (groups.length) refreshOptions(selectedOptions());
      setVariant(initial, restored);
      /* A link to a sold-out variant opened on the first available one: keep the URL in step. */
      if (initial && !restored && root.hasAttribute('data-cb-update-url') && window.history && window.history.replaceState) {
        try {
          var here = new URL(window.location.href);
          var asked = here.searchParams.get('variant');
          if (asked && asked !== String(initial.id)) {
            here.searchParams.set('variant', initial.id);
            window.history.replaceState(window.history.state, '', here.toString());
          }
        } catch (err) {
          /* The URL update is a nicety only. */
        }
      }
      schedule();
    }

    function initAll(scope) {
      var roots = (scope || document).querySelectorAll('[data-cb-pdp]');
      Array.prototype.forEach.call(roots, initPdp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        initAll();
      });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-pdp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // A Trustpilot TrustBox (or app block) renders into an iframe. The widget counts as on screen
    // only while a loaded iframe in the section has real height; the fallback quote cards hide then
    // and come back if the frame is removed or collapses (e.g. a blocked widget that stays empty).
    // Watched with a ResizeObserver where available, and re-checked every second for 10 seconds.
    // A blocked frame still fires "load" (with the browser's error page), so a Trustpilot frame also
    // needs a message from the widget itself (TrustBoxes talk to the page with postMessage) first.
    var tpHeard = false;
    var updaters = [];
    window.addEventListener('message', function (event) {
      if (/(^|\.)trustpilot\.com$/.test((event.origin || '').replace(/^https?:\/\//, ''))) {
        tpHeard = true;
        for (var i = 0; i < updaters.length; i++) updaters[i]();
      }
    });
    function isTrustpilot(frame) {
      return /trustpilot\.com/.test(frame.getAttribute('src') || '');
    }
    function watch(section) {
      var apps = section.querySelector('.cb-pdp-reviews__apps');
      if (!apps || section.getAttribute('data-cb-watch') === '1') return;
      section.setAttribute('data-cb-watch', '1');
      var resize = window.ResizeObserver ? new ResizeObserver(update) : null;
      updaters.push(update);
      function update() {
        var live = false;
        var frames = apps.querySelectorAll('iframe[data-cb-loaded]');
        for (var i = 0; i < frames.length; i++) {
          if (frames[i].offsetHeight > 40 && (tpHeard || !isTrustpilot(frames[i]))) live = true;
        }
        section.classList.toggle('cb-pdp-reviews--live', live);
      }
      function scan() {
        var frames = apps.querySelectorAll('iframe');
        for (var i = 0; i < frames.length; i++) {
          var frame = frames[i];
          if (frame.getAttribute('data-cb-seen')) continue;
          frame.setAttribute('data-cb-seen', '1');
          frame.addEventListener('load', function (event) {
            event.target.setAttribute('data-cb-loaded', '');
            update();
          });
          if (resize) resize.observe(frame);
        }
        update();
      }
      scan();
      if (window.MutationObserver) new MutationObserver(scan).observe(apps, { childList: true, subtree: true });
      var ticks = 0;
      var timer = setInterval(function () {
        update();
        ticks += 1;
        if (ticks >= 10) clearInterval(timer);
      }, 1000);
    }
    function init() {
      var sections = document.querySelectorAll('.cb-pdp-reviews[data-cb-reviews-swap]');
      for (var i = 0; i < sections.length; i++) watch(sections[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-proof-strip"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cb-proof-row')) return;
    // Makes the row keyboard scrollable (tabindex) only while it actually overflows (phones).
    class CbProofRow extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cb-proof__list');
        if (!this.list || !('ResizeObserver' in window)) return;
        // Next frame, so the attribute change never lands inside the observer's own loop (as cb-shop-lines).
        this.observer = new ResizeObserver(() => requestAnimationFrame(() => this.update()));
        this.observer.observe(this.list);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      update() {
        if (this.list.scrollWidth > this.list.clientWidth + 1) {
          this.list.setAttribute('tabindex', '0');
        } else {
          this.list.removeAttribute('tabindex');
        }
      }
    }
    customElements.define('cb-proof-row', CbProofRow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-tagline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('cb-tagline-row')) return;
    // Phones, swipe layout: the row is keyboard scrollable (tabindex) only while it overflows.
    class CbTaglineRow extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.cb-tagline__panels');
        if (!this.list || !('ResizeObserver' in window)) return;
        // Next frame, so the attribute change never lands inside the observer's own loop (as cb-shop-lines).
        this.observer = new ResizeObserver(() => requestAnimationFrame(() => this.update()));
        this.observer.observe(this.list);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
      update() {
        if (this.list.scrollWidth > this.list.clientWidth + 1) {
          this.list.setAttribute('tabindex', '0');
        } else {
          this.list.removeAttribute('tabindex');
        }
      }
    }
    customElements.define('cb-tagline-row', CbTaglineRow);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
